<template>
  <div>
    <template v-if="!IsDetail">
      <el-row style="margin-bottom:10px;">
        <el-col :span="4">
          <el-upload
            :headers="{ Authorization: 'Bearer ' + token }"
            :action="uploadUrl"
            :on-progress="uploadVideoProcess"
            :on-success="handleVideoSuccess"
            :before-upload="beforeUploadVideo"
            :show-file-list="false"
          >
            <el-button type="primary" size="mini" @click="onClick">添加</el-button>
          </el-upload>
        </el-col>
        <el-col :span="20">
          <el-progress
            v-show="showProgress"
            style="margin-top:6px;"
            :percentage="videoUploadPercent"
          />
        </el-col>
      </el-row>
      <span style="font-size: 12px;color: #909399;">请上传 mp4 格式的视频，视频不能超过{{fileSize}}Mb</span>
    </template>
    <el-row v-loading="isLoading" v-if="value" class="upload-item">
      <el-col :span="2">
        <i class="el-icon-video-camera" style="margin-left:10px;"></i>
      </el-col>
      <el-col :span="18">
        <span>{{value}}</span>
      </el-col>
      <el-col :span="4">
        <el-button type="text" icon="el-icon-video-play" @click="playVideo"></el-button>
        <el-popconfirm
          title="确定删除吗？"
          v-if="!IsDetail"
          @onConfirm="onDelete"
          @confirm="onDelete"
          style="margin-left:10px"
        >
          <el-button type="text" slot="reference" icon="el-icon-delete"></el-button>
        </el-popconfirm>
      </el-col>
    </el-row>
    <el-dialog
      :append-to-body="true"
      title="视频预览"
      :visible.sync="dialogPlay"
      width="30%"
      @close="closeDialog"
    >
      <video :src="videoUrl" controls autoplay ref="dialogVideo" width="100%"></video>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/api/common/common";
export default {
  props: {
    value: {
      type: String,
      default: undefined,
    },
    uploadUrl: {
      type: String,
      default: "/api" + api.uploadPhotoUrl,
    },
    deleteFunc: {
      type: Function,
      default: api.deletePhoto,
    },
    type: {
      type: String,
      default: undefined,
    },
    IsDetail: {
      type: Boolean,
      default: false,
    },
    //文件大小，默认50Mb
    fileSize: {
      type: Number,
      default: 50,
    },
  },
  data() {
    return {
      isLoading: false,
      token: this.$commonJs.getCookie("token"),
      videoUrl: "",
      dialogPlay: false,

      showProgress: false, //显示进度条
      videoUploadPercent: 0, //进度条的进度
    };
  },
  computed: {
    fileList() {
      if (!this.value) return [];
      return [
        {
          url: "/api" + this.value,
        },
      ];
    },
    // header() {
    //   let token = localStorage.getItem("token");
    //   if (token) {
    //     return { Authorization: "Bearer " + token };
    //   }
    //   return {};
    // },
  },
  methods: {
    onClick() {
      console.log("get_new_token");
      this.token = this.$commonJs.getCookie("token");
    },
    //上传前回调
    beforeUploadVideo(file) {
      console.log("beforeUploadVideo");
      var fileSize = file.size / 1024 / 1024 < this.fileSize;
      if (
        [
          "video/mp4",
          // "video/ogg",
          // "video/flv",
          // "video/avi",
          // "video/wmv",
          // "video/rmvb",
          // "video/mov"
        ].indexOf(file.type) == -1
      ) {
        this.$message.warning("请上传正确的视频格式");
        return false;
      }
      if (!fileSize) {
        this.$message.warning(`视频大小不能超过${this.fileSize}Mb`);
        return false;
      }
      this.showProgress = true;
    },
    //进度条
    uploadVideoProcess(event, file, fileList) {
      this.videoUploadPercent = file.percentage.toFixed(0) * 1;
    },
    //上传成功回调
    handleVideoSuccess(res, file) {
      // console.log(res);
      this.$emit("input", res.Data);

      this.showProgress = false;
      this.videoUploadPercent = 0;

      if (res.Code != 0) {
        this.$message.warning(res.Message);
      }
    },
    onDelete(res) {
      console.log(res,"ondelete");
      this.$emit("input", "");
      // this.isLoading = true;
      // this.deleteFunc(this.value).then(res => {
      //   console.log("delete");
      //   this.isLoading = false;
      //   if (res.Code == 0) {
      //     this.$emit("input", "");
      //   } else {
      //     this.$message.error(res.Msg);
      //   }
      // });
    },
    onPreview() {
      this.$refs.img.clickHandler();
    },
    // 视频播放
    playVideo() {
      this.dialogPlay = true;
      this.videoUrl = "/api" + this.value;
    },
    closeDialog() {
      console.log("close");
      if (this.$refs.dialogVideo.paused) {
        this.$refs.dialogVideo.play();
      } else {
        this.$refs.dialogVideo.pause();
      }
      this.videoUrl = ""; //清空数据 关闭视频播放
    },
  },
};
</script>

<style lang="scss">
.upload-item {
  height: 40px;
  line-height: 40px;
}
</style>